import { Button, Paper, Typography } from '@mui/material';
import Image from '../Image/Image';

import stringUtils from '../../utils/StringUtils';

import './DenounceSummary.scss';

function DenounceSummary ({denounce, handleGoToDenounceDetails}) {
  const initialPicture = denounce?.vector_focus?.picture?.url;
  const address = stringUtils.getPrettyAddress({ 
    city: denounce?.city?.name,
    address: denounce?.vector_focus?.address
  });
  const denounceStatus = stringUtils.getPrettyDenounceStatus(denounce?.denounce_status?.name);
  const initialDescription = denounce?.description;
  const agentVisitDate = stringUtils.getPrettyDateTime(denounce?.visited_at);
  const agentFeedback = denounce?.agent_feedback || '...';

  const handleClickGoToDetails = () => {
    handleGoToDenounceDetails(denounce?.id);
  };

  return (
    <Paper elevation={2} className="denounce-summary">
      {initialPicture && <Image className="vector-focus-image" src={initialPicture} />}
      <div className="content">
        <Typography variant="p" component="p"><b>Endereço:</b> {address}</Typography>
        <Typography variant="p" component="p"><b>Status:</b> {denounceStatus}</Typography>
        <Typography variant="p" component="p"><b>Descrição:</b> {initialDescription}</Typography>
        <Typography variant="p" component="p"><b>Data da visita:</b> {agentVisitDate}</Typography>
        <Typography variant="p" component="p"><b>Observação do agente:</b> {agentFeedback}</Typography>
      </div>
      <div className="action-buttons">
        <Button className="see-details-btn" onClick={handleClickGoToDetails}>Detalhes da denúncia</Button>
      </div>
    </Paper>
  );
};

export default DenounceSummary;
